import { modal } from "@gtmhub/core/routing";

export const employeeState = modal({
  name: ".employee",
  data: {
    trackingPage: "Employee Details",
  },
  url: ":employeeId/employee-details/",
  component: "employeeProfile",
  windowClass: "profile-sidebar",
});
